import React, { useState } from 'react';
import './App.css';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import VillaLayout from './components/VillaLayout';
import Amenities from './components/Amenities';
import Gallery from './components/Gallery';
import Location from './components/Location';
import Activities from './components/Activities';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import BookingSidebar from './components/BookingSidebar';

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = () => setBookingOpen(true);

  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white text-stone-900 antialiased">
        <Header onBookClick={openBooking} />
        <main>
          <Hero onBookClick={openBooking} />
          <About />
          <VillaLayout />
          <Amenities />
          <Gallery />
          <Location />
          <Activities />
          <Contact />
        </main>
        <Footer />
        <BookingSidebar onBookClick={openBooking} />
        <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} />
      </div>
    </LanguageProvider>
  );
}

export default App;
